import dayjs from 'dayjs';
import * as yup from 'yup';

const minDate = '1800-01-01';
const toNullIfEmpty = (v: unknown) => (v === '' || v === undefined ? null : v);

export const giftSearchSchema = (t) =>
  yup.object({
    // Validering - Om from är längre fram än t.o.m
    dateTo: yup
      .string()
      .nullable()
      .transform(toNullIfEmpty)
      .test('valid-dateTo', 'Ogiltigt till-datum', (v) => {
        if (!v) return true;
        const d = new Date(v);
        return !Number.isNaN(d.getTime());
      }),
    dateFrom: yup
      .string()
      .nullable()
      .transform(toNullIfEmpty)
      .test('valid-dateFrom', t('common:validationMessages.invalidDateFormat'), (v) => {
        if (!v) return true;
        const d = new Date(v);
        return !Number.isNaN(d.getTime());
      })
      // eslint-disable-next-line func-names
      .test('date-range', t('gift:dateRange'), function (value) {
        // eslint-disable-next-line react/no-this-in-sfc
        const { dateTo } = this.parent as { dateTo?: string | null };
        if (!dateTo || !value) return true;
        return new Date(dateTo).getTime() >= new Date(value).getTime();
      })
      .test('min-dateFrom', t('common:validationMessages.invalidDateFormat', { date: minDate }), (v) => {
        if (!v) return true;
        return !dayjs(v).isBefore(dayjs(minDate), 'day');
      }),
  });
